module.exports = __webpack_public_path__ + "img/input_display.c5da198c.png";